import { FORM_FIELDS } from './constants';
import { yupResolver } from '@hookform/resolvers/yup';
import { getCreditCardValidation } from '@ott/credit-card';
import { l10n } from '@ott/l10n';
import { selectors as virtualCardSelectors } from '@ott/shared-virtual-card-logic';
import { createSelector } from 'reselect';
import * as yup from 'yup';
import { AnyObject } from 'yup/lib/types';

export const selectRefillFormValidation = createSelector(
  virtualCardSelectors.selectIsIdentified,
  virtualCardSelectors.getCardInfo,
  (isUPRID, { data }) => {
    const { balance = 0, limits } = data ?? {};

    const operationError = isUPRID
      ? l10n('virtualCard.refillForm.errors.amount.identifiedOperationLimit')
      : l10n('virtualCard.refillForm.errors.amount.baseOperationLimit');

    const balanceError = isUPRID
      ? l10n('virtualCard.refillForm.errors.amount.identifiedBalanceLimit')
      : l10n('virtualCard.refillForm.errors.amount.baseBalanceLimit');

    const creditCardValidation = getCreditCardValidation();

    const creditCardScheme = {
      [FORM_FIELDS.cardNumber]: yup.string().when(FORM_FIELDS.selectedId, {
        is: (id: string) => !id,
        then: creditCardValidation[FORM_FIELDS.cardNumber].required(l10n('required.required')),
      }),
      [FORM_FIELDS.cardHolder]: yup.string().when(FORM_FIELDS.selectedId, {
        is: (id: string) => !id,
        then: creditCardValidation[FORM_FIELDS.cardHolder].required(l10n('required.required')),
      }),
      [FORM_FIELDS.month]: yup.string().when(FORM_FIELDS.selectedId, {
        is: (id: string) => !id,
        then: creditCardValidation[FORM_FIELDS.month],
      }),
      [FORM_FIELDS.year]: yup.string().when(FORM_FIELDS.selectedId, {
        is: (id: string) => !id,
        then: creditCardValidation[FORM_FIELDS.year],
      }),
      [FORM_FIELDS.cvv]: creditCardValidation[FORM_FIELDS.cvv],
    };

    return yupResolver<yup.AnyObjectSchema>(
      yup.object({
        ...creditCardScheme,
        amount: yup
          .number()
          .required(l10n('required.required'))
          .test((value, { createError, path }: yup.TestContext<AnyObject>) => {
            const amount = Number(value);
            const nextBalance = amount + balance;
            const isNextBalanceValid = nextBalance <= (limits?.balance ?? 0);

            if (amount > Number(limits?.operation)) {
              return createError({
                message: operationError,
                path,
              });
            }

            if (!isNextBalanceValid) {
              return createError({
                message: balanceError,
                path,
              });
            }

            return true;
          }),
      })
    );
  }
);
